import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { rbacApi } from '../../Api/superadminApicall';

// Async thunks
export const fetchPermissions = createAsyncThunk(
  'permissions/fetchPermissions',
  async ({ page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.permissions.list(page, limit, search);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch permissions');
    }
  }
);

export const createPermission = createAsyncThunk(
  'permissions/createPermission',
  async (permissionData, { rejectWithValue }) => {
    try {
      const response = await rbacApi.permissions.create(permissionData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create permission');
    }
  }
);

export const updatePermission = createAsyncThunk(
  'permissions/updatePermission',
  async ({ permissionId, permissionData }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.permissions.update(permissionId, permissionData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update permission');
    }
  }
);

export const deletePermission = createAsyncThunk(
  'permissions/deletePermission',
  async (permissionId, { rejectWithValue }) => {
    try {
      await rbacApi.permissions.delete(permissionId);
      return permissionId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete permission');
    }
  }
);


const permissionsSlice = createSlice({
    name: "permissions",
    initialState: {
        permissiondata: [],
        // permissionadd: [],
        // permissionupdate: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPermissions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPermissions.fulfilled, (state, action) => {
                state.loading = false;
                state.permissiondata = action.payload;
            })
            .addCase(fetchPermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createPermission.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createPermission.fulfilled, (state, action) => {
                state.loading = false;
                state.permissionadd = action.payload;
            })
            .addCase(createPermission.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updatePermission.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatePermission.fulfilled, (state, action) => {
                state.loading = false;
                // Optionally update chatMessages if API returns updated messages
                // Otherwise, we'll refetch messages after sending
            })
            .addCase(updatePermission.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deletePermission.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deletePermission.fulfilled, (state, action) => {
                state.loading = false;
                // Remove deleted permission from the list
                if (Array.isArray(state.permissiondata)) {
                    state.permissiondata = state.permissiondata.filter(
                        permission => permission.id !== action.payload
                    );
                } else if (state.permissiondata?.data?.items) {
                    state.permissiondata.data.items = state.permissiondata.data.items.filter(
                        permission => permission.id !== action.payload
                    );
                }
            })
            .addCase(deletePermission.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, clearSuccess, resetState } = permissionsSlice.actions;
export default permissionsSlice.reducer;